import { defineStore } from 'pinia'

export const useCommonStore = defineStore('common', {
  state: () => ({
    language: '',
    domain: '',
    // 当前子站图片 CDN 域名，由后端按子站下发；默认回退 env 旧域名，避免空值导致图片裂开
    imgDomain: import.meta.env.VITE_IMG_BASE_PATH,
    isRecaptchaLoaded: false
  }),
  actions: {
    setLang(lang: string) {
      this.language = lang
    },
    setDomain(domain?: string) {
      if (domain) {
        this.domain = domain
      }
    },
    setImgDomain(domain?: string) {
      if (domain) {
        this.imgDomain = domain
      }
    },
    setRecaptchaLoaded(isRecaptchaLoaded?: boolean) {
      this.isRecaptchaLoaded = isRecaptchaLoaded
    }
  }
})
